/**
 * Calcula o período de comparação baseado no período atual.
 * Retorna { dataMin, dataMax, textoComparacao } (YYYY-MM-DD).
 */
export const calcularPeriodoComparacao = (dataMin, dataMax, periodo) => {
  if (!dataMin || !dataMax) return null;

  const formatarData = (data) => {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  const parsearData = (dataStr) => {
    const [ano, mes, dia] = dataStr.split('-').map(Number);
    return new Date(ano, mes - 1, dia);
  };

  try {
    const inicioAtual = parsearData(dataMin);
    const fimAtual = parsearData(dataMax);
    const diffDias = Math.floor((fimAtual - inicioAtual) / (1000 * 60 * 60 * 24));

    let inicioAnterior, fimAnterior, textoComparacao;

    switch (periodo) {
      case 'hoje': {
        inicioAnterior = new Date(inicioAtual);
        inicioAnterior.setDate(inicioAnterior.getDate() - 1);
        fimAnterior = new Date(inicioAnterior);
        textoComparacao = 'ontem';
        break;
      }
      case 'ontem': {
        inicioAnterior = new Date(inicioAtual);
        inicioAnterior.setDate(inicioAnterior.getDate() - 1);
        fimAnterior = new Date(inicioAnterior);
        textoComparacao = 'anteontem';
        break;
      }
      case 'esta_semana': {
        const inicioSemanaPassada = new Date(inicioAtual);
        inicioSemanaPassada.setDate(inicioSemanaPassada.getDate() - 7);
        const fimSemanaPassada = new Date(inicioSemanaPassada);
        fimSemanaPassada.setDate(fimSemanaPassada.getDate() + 6);
        inicioAnterior = inicioSemanaPassada;
        fimAnterior = fimSemanaPassada;
        textoComparacao = 'semana passada';
        break;
      }
      case 'semana_passada': {
        inicioAnterior = new Date(inicioAtual);
        inicioAnterior.setDate(inicioAnterior.getDate() - 7);
        fimAnterior = new Date(fimAtual);
        fimAnterior.setDate(fimAnterior.getDate() - 7);
        textoComparacao = '2 semanas atrás';
        break;
      }
      case 'este_mes': {
        const mesAnterior = new Date(inicioAtual);
        mesAnterior.setMonth(mesAnterior.getMonth() - 1);
        inicioAnterior = new Date(mesAnterior.getFullYear(), mesAnterior.getMonth(), 1);
        fimAnterior = new Date(mesAnterior.getFullYear(), mesAnterior.getMonth() + 1, 0);
        textoComparacao = 'mês passado';
        break;
      }
      case 'mes_passado': {
        const doisMesesAtras = new Date(inicioAtual);
        doisMesesAtras.setMonth(doisMesesAtras.getMonth() - 1);
        inicioAnterior = new Date(doisMesesAtras.getFullYear(), doisMesesAtras.getMonth(), 1);
        fimAnterior = new Date(doisMesesAtras.getFullYear(), doisMesesAtras.getMonth() + 1, 0);
        textoComparacao = '2 meses atrás';
        break;
      }
      case 'este_ano': {
        const anoAnterior = inicioAtual.getFullYear() - 1;
        inicioAnterior = new Date(anoAnterior, 0, 1);
        fimAnterior = new Date(anoAnterior, 11, 31);
        textoComparacao = 'ano passado';
        break;
      }
      case 'ano_passado': {
        const doisAnosAtras = inicioAtual.getFullYear() - 1;
        inicioAnterior = new Date(doisAnosAtras, 0, 1);
        fimAnterior = new Date(doisAnosAtras, 11, 31);
        textoComparacao = '2 anos atrás';
        break;
      }
      case 'customizado':
      default: {
        if (diffDias > 180) {
          inicioAnterior = new Date(inicioAtual);
          inicioAnterior.setFullYear(inicioAnterior.getFullYear() - 1);
          fimAnterior = new Date(fimAtual);
          fimAnterior.setFullYear(fimAnterior.getFullYear() - 1);
          textoComparacao = 'mesmo período ano anterior';
        } else if (diffDias > 25) {
          const mesAnt = new Date(inicioAtual);
          mesAnt.setMonth(mesAnt.getMonth() - 1);
          inicioAnterior = new Date(mesAnt.getFullYear(), mesAnt.getMonth(), 1);
          fimAnterior = new Date(mesAnt.getFullYear(), mesAnt.getMonth() + 1, 0);
          textoComparacao = 'mês anterior';
        } else if (diffDias >= 6) {
          inicioAnterior = new Date(inicioAtual);
          inicioAnterior.setDate(inicioAnterior.getDate() - 7);
          fimAnterior = new Date(fimAtual);
          fimAnterior.setDate(fimAnterior.getDate() - 7);
          textoComparacao = 'semana anterior';
        } else {
          inicioAnterior = new Date(inicioAtual);
          inicioAnterior.setDate(inicioAnterior.getDate() - (diffDias + 1));
          fimAnterior = new Date(fimAtual);
          fimAnterior.setDate(fimAnterior.getDate() - (diffDias + 1));
          textoComparacao = 'período anterior';
        }
        break;
      }
    }

    return {
      dataMin: formatarData(inicioAnterior),
      dataMax: formatarData(fimAnterior),
      textoComparacao,
    };
  } catch (error) {
    console.error('Erro ao calcular período de comparação:', error);
    return null;
  }
};

